module.exports = __webpack_public_path__ + "img/userB06.134a73a4.jpg";